import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-tax",
  "use": "icon-soc-tax-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-tax\">\r\n<g transform=\"translate(-113.571 -54.924) scale(1.221818)\">\r\n<path d=\"M512 128L864 800H160L512 128zm0 160L288 704h448L512 288z\" />\r\n  <path d=\"M480 448h64v128h-64V448zm0 176h64v64h-64v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-tax.svg
// module id = 1nHT
// module chunks = 446